import { useContext } from "react";
import { LangContext, LangContextType } from "../utilities/customHooks";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import textData from "../textData.json";
import { LightbulbIcon } from "./icons/DashboardIcons";

const founderDashboards = textData.Pages.Dashboards.FounderDashboards as Record<string, Record<string, Record<string, string>>>;

function EducationSection({
  textPrefix,
  bulletTextPrefix,
  buttonTextPrefix,
}: {
  textPrefix: string;
  bulletTextPrefix?: string;
  buttonTextPrefix?: string;
}) {
  const navigate = useNavigate();
  const { langState } = useContext(LangContext) as LangContextType;
  const titleSource = founderDashboards[textPrefix];
  const bulletSource = founderDashboards[bulletTextPrefix || textPrefix];
  const buttonSource = founderDashboards[buttonTextPrefix || textPrefix];

  return (
    <div className="educationCont">
      <div className="flex justify-between w-full">
        <div className="flex-col gap-2">
          <h3 className="font-semibold">{titleSource.EducationTitle[langState]}</h3>
          <ul className="list-disc ml-8 ">
            <li>{bulletSource.EducationBullet1[langState]}</li>
            <li>{bulletSource.EducationBullet2[langState]}</li>
            <li>{bulletSource.EducationBullet3[langState]}</li>
          </ul>
        </div>
        <LightbulbIcon />
      </div>
      <Button
        buttonText={buttonSource.EducationButton[langState]}
        buttonType='secondaryFull'
        actionHandler={() => navigate("/dashboard/education")}
      />
    </div>
  );
}

export default EducationSection;
